<template>


		<div id="container">
			<div class="location">
				<ul>
					<li class="home">홈</li>
					<li>적하보험</li>
					<li>계약</li>
					<li>개인/법인회원 정보 조회 및 수정</li>
				</ul>
			</div>

			<div class="pageTit">
				<div class="conWrap">
					<h2>회원정보</h2>
				</div>
			</div>

			<div class="contents">
				<div class="conWrap">
					<h3 class="conTit">회원 정보 조회 및 수정</h3>
					<div class="tabStyle1">
						<table>
							<caption>보험료 견적</caption>
							<colgroup>
								<col width="200">
								<col width="*">
							</colgroup>
							<tbody>
								<tr>
									<th scope="row">
										<label for="id">ID</label>
									</th>
									<td colspan="3">
										<div class="inpTxt">
											<input type="text" v-model="state.userInfo.login_id" id="id" title="ID" disabled>
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="pwd">비밀번호</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input @click="openPopup('PopPwChange')" type="password" value="*********" id="pwd" placeholder="입력해 주세요" title="비밀번호">
										</div>
										<p class="inpInfo fcRed">비밀번호 변경을 원하는 경우, 입력창을 클릭하세요.</p>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="jobKo">직장한글명</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input type="text" maxlength="19"  v-model="state.userInfo.n_ctorkr" id="jobKo" title="직장한글명">
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="jobEn">직장영문명</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input type="text"  maxlength="50" v-model="state.userInfo.n_ctoren" id="jobEn" title="직장영문명">
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label>사업자구분</label>
									</th>
									<td colspan="3">
										<div class="inpSlt typeReq">
											<button type="button" name="ind_corp_typ_cd"  class="sltBtn" title="사업자구분"><span>{{state.ind_corp_typ_cd.name}}</span></button>
											<ul >
												<li ><button type="button" @click="setOption('corp','C')" value="C" class="sltOpt"><span>법인사업자</span></button></li><!-- 체크되어있는 버튼에 title="선택" 추가 -->
												<li><button type="button" @click="setOption('corp','P')" value="P" class="sltOpt"><span>개인사업자</span></button></li>
												<li><button type="button" @click="setOption('corp','S')" value="S" class="sltOpt"><span>서베이</span></button></li>
												<li><button type="button" @click="setOption('corp','A')" value="A" class="sltOpt"><span>관리자</span></button></li>
											</ul>
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label>인수형태</label>
									</th>
									<td colspan="3" v-if="state.polhd_gb != ''">
										<div class="inpSlt typeReq">
											<button type="button" name="polhd_gb" class="sltBtn" title="인수형태구분"><span>{{state.polhd_gb.name}}</span></button>
											<ul>
												<li><button type="button" @click="setOption('pol','1')" value="1" class="sltOpt" title="선택"><span>당사 단독</span></button></li><!-- 체크되어있는 버튼에 title="선택" 추가 -->
												<li><button type="button"  @click="setOption('pol','2')" value="2" class="sltOpt"><span>당사 간사</span></button></li>
											</ul>
										</div>
									</td>
									<td colspan="3"  v-if="state.polhd_gb == ''">
										<div class="typeSplit5">
											<div class="inpTxt">
												<input type="text" value=" 등록된 인수형태 코드가 없습니다." readonly>
											</div>
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="bizNum">사업자번호</label>
									</th>
									<td colspan="3">
										<div class="typeSplit5">
											<div class="inpTxt">
												<input type="text" v-model="state.userInfo.biz_no" id="bizNum" title="사업자번호" disabled>
											</div>

										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="phone">휴대폰번호</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input type="text" style="width:32%;margin: 3px;" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" v-model="state.userInfo.celfon_no1" maxlength="4"  id="phone1" title="휴대폰번호">-
											<input type="text" style="width:32%;margin: 3px;" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" v-model="state.userInfo.celfon_no2" maxlength="4"  id="phone2" title="휴대폰번호">-
											<input type="text" style="width:32%" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" v-model="state.userInfo.celfon_no3" maxlength="4"  id="phone3" title="휴대폰번호">
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="bir">생년월일</label>
									</th>
									<td colspan="3">
										<div class="form_input_area type_calendar inpTxt typeReq" style="width:32%">
											<datepicker
												v-model="state.userInfo.birth_ymd"
												:locale="ko"
												class="form_input"
												inputFormat="yyyy-MM-dd"
												readonly
											/>
											<button type="button" class="btn_calendar">
												<span>날짜선택</span>
											</button>
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="division">부서</label>
									</th>
									<td>
										<div class="inpTxt typeReq">
											<input type="text" v-model="state.userInfo.dept_nm"  id="division" title="부서">
										</div>
									</td>
									<th scope="row">
										<label for="name">담당자명</label>
									</th>
									<td>
										<div class="inpTxt typeReq">
											<input maxlength="5" type="text" v-model="state.userInfo.charg_nm" id="name" title="담당자명">
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="code">담당자코드</label>
									</th>
									<td colspan="3">
										<div class="inpTxt">
											<input type="text" v-model="state.userInfo.gita" id="code" title="담당자코드">
										</div>
									</td>
								</tr>
								<tr>
									<th>
										<label>협정비협정구분</label>
									</th>
									<td colspan="3">
										<div class="inpSlt">
											<button type="button" class="sltBtn" title="협정비협정 구분 선택"><span>{{state.agrmNagrm.name}}</span></button>
											<ul>
												<li><button type="button" value="1" class="sltOpt" title="선택" @click="setOption('agrmN','1')"><span>협정</span></button></li><!-- 체크되어있는 버튼에 title="선택" 추가 -->
												<li><button type="button" value="2" class="sltOpt" @click="setOption('agrmN','2')"><span>비협정</span></button></li>
											</ul>
										</div>
									</td>
								</tr>
								<tr>
									<th>
										<label>수입 상품, 단위상품코드</label>
									</th>
									<td colspan="3">
										<div class="inpSlt">
											<button type="button" name="incPayKind" class="sltBtn" id="code" title="수입">
												<span>{{state.incmProd.name}}</span>
											</button>
											<ul>
												<li v-for="(item, index) in state.incmProdList" :key="index">
													<button
													type="button"
													class="sltOpt"
													:value="item.code"
													@click="setOption('incm', item.code)"
													>
													<span>{{item.name}}</span>
													</button>
												</li>
											</ul>
										</div>
									</td>
								</tr>
								<tr>
									<th>
										<label>수출 상품, 단위상품코드</label>
									</th>
									<td colspan="3">
										<div class="inpSlt">
											<button type="button" name="xprtPayKind" class="sltBtn" id="code" title="수출">
												<span>{{state.exptProd.name}}</span>
											</button>
											<ul>
												<li v-for="(item, index) in state.exptProdList" :key="index">
												<button 
												type="button"
												class="sltOpt"
												:value="item.code"
												@click="setOption('expt', item.code)"
												>
												<span>{{item.name}}</span>
												</button>
												</li>
											</ul>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<tr>
						<td><br/>※상기의 법인정보는 "신정보"에서 변경 된 경우에만, 변경된 정보만 확인 가능합니다.(필수정보는 제외함)</td>
					</tr>
					<div class="btnWrap">
						<a @click="admMgrList()" class="btnType sizeR colorBL"><span>목록</span></a>
						<a @click="memberUpd()" class="btnType sizeR colorB"><span>수정</span></a>
					</div>
				</div>
			</div>
		</div>
		<PopPwChange ref="PopPwChangeRef" @close="handlePopupClose"></PopPwChange>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import util from '@/common/util';
import { sessionUserInfo, load } from '@/common/sessionFactory';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import PopPwChange from '@/components/common/layerPop/PopPwChange.vue';
import Datepicker from 'vue3-datepicker';
import { ko } from 'date-fns/locale';
import * as codeList from "@/common/code";


const PopPwChangeRef = ref(null);
const router = useRouter() 
const swalAlert = inject("swalAlert");
const swalConfirm = inject("swalConfirm");
const axios = inject('axios');
const store = useStore();


const state = reactive({
	logid : '',
	bizNo : '',
	userInfo : {},
	currDateFormat: util.formatDate(new Date(), "yyyy-mm-dd"),
	
	//
	incmProdList : [], //수입 리스트
	exptProdList : [], //수출 리스트
	agrmNList : [], //협정 비협정 리스트
	indCorpTypList :[],//사업자 구분 리스트
	polhdGbList : [],

	incmProdTmp :'',
	exptProdTmp : '',
	incmProd : '',
	exptProd :'',
	agrmNagrm : '',
	ind_corp_typ_cd :'',
	polhd_gb : '',
});

onMounted(async () => {	
	await load()
	state.incmProdList = codeList.getIncmProdList;
	state.exptProdList = codeList.getExptProdList
	state.agrmNList = codeList.getAgrmNList;
	state.indCorpTypList = codeList.getIndCorpTypCd;
	state.polhdGbList = codeList.getPolhdGb;

	let param = {}
	param.login_id = store.state.common.login_id
	param.biz_no = store.state.common.biz_no
	param.corp_no_enc = store.state.common.corp_no_enc

	await axios.json('/confirUsrDeta.do', param).then(function(result){
		state.userInfo = rmSpaceObject(result.data.info);
		state.userInfo.birth_ymd = new Date(state.userInfo.birth_ymd);
		console.log("state.userInfo",state.userInfo)
		// state.exptProdList = result.data.exptProdList;
		// state.incmProdList = result.data.incmProdList;

		state.incmProdTmp = state.userInfo.incm_prod_cd + "|" + state.userInfo.incm_unit_prod_cd;
		state.exptProdTmp = state.userInfo.expt_prod_cd + "|" + state.userInfo.expt_unit_prod_cd;

		
		//사업자 구분
		state.ind_corp_typ_cd = _.find(state.indCorpTypList, (d) => {
		return d.code.startsWith(state.userInfo.ind_corp_typ_cd);
		}) || "";

		//인수형태
		state.polhd_gb = _.find(state.polhdGbList, (d) => {
		return d.code.startsWith(state.userInfo.polhd_gb.trim());
		}) || '';
		console.log(state.polhd_gb)
		
		//협정 비협정
		state.agrmNagrm = _.find(state.agrmNList, (d) => {
        return d.code.startsWith(state.userInfo.agrm_nagrm_typ_cd);
		}) || "";

		//수입
		state.incmProd = _.find(state.incmProdList, (d) => {
        return d.code.startsWith(state.incmProdTmp);
		}) || "";

		//수출
		state.exptProd = _.find(state.exptProdList, (d) => {
        return d.code.startsWith(state.exptProdTmp);
		}) || "";

	})
})


const openPopup = (name) => {
  if ("PopPwChange" == name) {
    PopPwChangeRef.value.open({
		login_id  : state.userInfo.login_id,
		biz_no	   : state.userInfo.biz_no,
    });
  }
};

const setOption = (type, o) =>{
	console.log(type, o)
	switch (type) {
		case "agrmN":
			state.agrmNagrm = _.find(state.agrmNList, (d) => {
			return d.code.startsWith(o);
			}) || "";
			break;
		case "pol":
			state.polhd_gb = _.find(state.polhdGbList, (d) => {
			return d.code.startsWith(o);
			}) || "";
			break;
		case "corp":
			state.ind_corp_typ_cd = _.find(state.indCorpTypList, (d) => {
			return d.code.startsWith(o);
			}) || "";
			break;
		case "incm":
			state.incmProd = _.find(state.incmProdList, (d) => {
			return d.code.startsWith(o);
			}) || "";
			break;  
		case "expt":
			state.exptProd = _.find(state.exptProdList, (d) => {
			return d.code.startsWith(o);
			}) || "";
		break;
	}
}
console.log(state.o)

const memberUpd = () => {

	if(_.isEmpty(state.userInfo.n_ctorkr)){
		return swalAlert("직장한글명을 입력해주세요.")
	}else if(_.isEmpty(state.userInfo.n_ctoren)){
		return swalAlert("직장영문명을 입력해주세요.")
	}else if(_.isEmpty(util.formatDate(state.userInfo.birth_ymd, 'yyyy-mm-dd'))){
		return swalAlert("생년월일을 입력해주세요.")
	}else if(_.isEmpty(state.userInfo.dept_nm)){
		return swalAlert("부서명을 입력해주세요.")
	}else if(_.isEmpty(state.userInfo.charg_nm)){
		return swalAlert("담당자명을 입력해주세요.")
	}


	let param = {};
	param.corp_no = state.userInfo.corp_no;
	param.login_id = state.userInfo.login_id;
	param.n_ctorkr = state.userInfo.n_ctorkr;
	param.n_ctoren = _.toUpper(state.userInfo.n_ctoren);
	param.biz_no   = state.userInfo.biz_no;
	param.birth_ymd = util.formatDate(state.userInfo.birth_ymd, 'yyyy-mm-dd');
	param.dept_nm =	state.userInfo.dept_nm;
	param.charg_nm = state.userInfo.charg_nm;
	param.ind_corp_typ_cd = state.ind_corp_typ_cd.code;
	param.polhd_gb = state.polhd_gb.code;
	param.agrmNagrmDiv = state.agrmNagrm.code;
	param.incPayKind = state.incmProd.code;
	param.xprtPayKind = state.exptProd.code;
	param.txtGita = state.userInfo.gita;
	param.txtCelfon_No1 = state.userInfo.celfon_no1;
	param.txtCelfon_No2 = state.userInfo.celfon_no2;
	param.txtCelfon_No3 = state.userInfo.celfon_no3;

	swalConfirm("수정 하시겠습니까?").then((result) => {
        //예
		if (result.isConfirmed) {
			axios.json('/updateInfo.do', param).then(function(result){
			axios.json('/logHisLdg.do', {memo:"회원정보조회및수정" ,page:window.location.hash});
			return swalAlert(result.data.msg)
			})
		}
      });


}
function rmSpaceObject(obj){
	return _.mapValues(obj, value => _.isString(value) ? _.trim(value) : value);
}

const admMgrList = () =>{
	swalConfirm("리스트화면으로 이동하시겠습니까?").then((result) => {
        //예
		if (result.isConfirmed) {
		router.push({name: 'admMgr'})
		}
      });
}


</script>

<style>

</style>
